import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { queryClient } from "../App";

interface IUpdateComponentViewRanks {
  id: string;
  viewRank: string;
}

const useUpdateComponentViewRank = () =>
  useMutation({
    mutationFn: async (data: {
      data: IUpdateComponentViewRanks[];
    }) => {
      const response = await AXIOS_RESERVATION.put(`/v1/update-component-viewrank`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["services-components"] });
    },
  });

export default useUpdateComponentViewRank;